import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

// utils
import ImageUploader from "react-images-upload";
import axios from "axios";
import MyButton from "../../util/MyButton";

// MUI imports
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Rating from "@material-ui/lab/Rating";
import Grid from "@material-ui/core/Grid";

// Redux
import { connect } from "react-redux";
import {
  postPost,
  clearErrors,
  getProductFromUrl,
} from "../../redux/actions/dataActions";
import { LOADING_NEWPOST, STOP_LOADING_NEWPOST } from "../../redux/types";
import store from "../../redux/store";

const styles = (theme) => ({
  ...theme.spreadThis,
  submitButton: {
    position: "relative",
    float: "right",
    marginTop: 10,
  },
  progressSpinner: {
    position: "absolute",
  },
  closeButton: {
    position: "absolute",
    left: "91%",
    top: "6%",
  },
});

class PostPost extends Component {
  state = {
    open: false,
    review: "",
    size: "",
    rating: "",
    usualSize: "",
    itemUrl: "",
    errors: {},
    imageUrl: "data:",
    image: [],
    title: "",
    price: "",
    url: "",
    brand: "",
    id: "",
    available: "",
  };

  // open post dialog
  handleOpen = () => {
    this.setState({ open: true });
  };
  // close post dialog
  handleClose = () => {
    this.props.clearErrors();
    this.setState({
      open: false,
      errors: {},
      review: "",
      size: "",
      rating: "",
      usualSize: "",
      itemUrl: "",
      imageUrl: "data:",
      image: [],
      title: "",
      price: "",
      url: "",
      brand: "",
      id: "",
      available: "",
    });
  };
  // handle input change for text fields
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  // handle image upload for post
  handleImageChange = (picture, pictureURL) => {
    this.setState({
      image: picture.pop(),
      imageUrl: pictureURL.pop(),
    });
  };
  // when a user clicks the upload image button
  handleEditPicture = () => {
    const fileInput = document.getElementById("imageInput");
    fileInput.click();
  };
  // get the product based on url from user
  findProduct = async (event) => {
    var itemUrl = {
      url: this.state.itemUrl,
    };
    //console.log(itemUrl);
    //   this.props.getProductFromUrl(itemUrl).then((itemInfo) => {
    //   this.setState({ ...itemInfo });
    //   console.log(itemInfo)
    // });

    store.dispatch({ type: LOADING_NEWPOST });

    await axios
      .post(`/item`, itemUrl)
      .then((res) => {
        this.setState({ ...res.data });
        store.dispatch({ type: STOP_LOADING_NEWPOST });
      })
      .catch((err) => console.log(err));
  };
  // submit the post
  handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("item", this.state.title);
    formData.append("price", this.state.price);
    formData.append("review", this.state.review);
    formData.append("size", this.state.size);
    formData.append("rating", this.state.rating);
    formData.append("usualSize", this.state.usualSize);
    formData.append("itemImage", this.state.image, this.state.image.name);
    // formData.append("userHeight", this.props.user.credentials.height);
    // formData.append("userWeight", this.props.user.credentials.weight);
    // formData.append("userAge", this.props.user.credentials.age);
    formData.append("userHeight", this.props.user.userProfile.height);
    formData.append("userWeight", this.props.user.userProfile.weight);
    formData.append("userAge", this.props.user.userProfile.age);
    formData.append("itemUrl", this.state.itemUrl);
    formData.append("itemId", this.state.id);
    formData.append("brand", this.state.brand);

    await this.props.postPost(formData);
    this.handleClose();
  };
  render() {
    const {
      classes,
      UI: { loadingNewPost },
      user: {
        authenticated,
        //credentials: { handle, age, weight, height },
      },
    } = this.props;

    return authenticated ? (
      <Fragment>
        <MyButton onClick={this.handleOpen} tip="Post a fit!">
          <AddIcon />
        </MyButton>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle disableTypography>
            <Typography variant="h6">Post a new fit</Typography>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <form noValidate onSubmit={this.handleSubmit}>
              <TextField
                variant="outlined"
                size="small"
                name="itemUrl"
                type="text"
                label="Item URL"
                placeholder="Where did you buy it?"
                className={classes.textField}
                error={this.state.available === false ? "This brand is not supported!" : false}
                helperText={this.state.available === false ? "This brand is not supported! Enter details manually" : false}
                onChange={this.handleChange}
                autoFocus
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={this.findProduct}
                disabled={loadingNewPost}
              >
                Find Product
                {loadingNewPost && (
                  <CircularProgress
                    size={30}
                    className={classes.progressSpinner}
                  />
                )}
              </Button>
              <br></br>
              <TextField
                variant="outlined"
                size="small"
                name="title"
                type="text"
                label="Item name"
                placeholder="Name of the product"
                value={this.state.title}
                className={classes.textField}
                onChange={this.handleChange}
                autoFocus
              />
              <TextField
                variant="outlined"
                size="small"
                name="brand"
                type="text"
                label="Item brand"
                value={this.state.brand}
                placeholder="Brand of the product"
                className={classes.textField}
                onChange={this.handleChange}
                autoFocus
              />
              <TextField
                variant="outlined"
                size="small"
                name="price"
                type="text"
                label="Item price"
                value={this.state.price}
                placeholder="Price of the product"
                className={classes.textField}
                onChange={this.handleChange}
                autoFocus
              />

              <Grid container>
                <Grid item xs>
                  <TextField
                    variant="outlined"
                    size="small"
                    name="size"
                    type="text"
                    label="size"
                    placeholder="What size did you buy?"
                    className={classes.textField}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs>
                  <TextField
                    variant="outlined"
                    size="small"
                    name="usualSize"
                    type="text"
                    label="usual size"
                    placeholder="What's your usual size?"
                    className={classes.textField}
                    onChange={this.handleChange}
                  />
                </Grid>
              </Grid>

              <Typography component="legend">Rating</Typography>
              <Rating
                name="simple-controlled"
                value={this.state.rating}
                onChange={(event, newValue) => {
                  this.setState({ rating: newValue });
                }}
              />
              <TextField
                variant="outlined"
                name="review"
                type="text"
                label="review"
                placeholder="Review your fit"
                className={classes.textField}
                onChange={this.handleChange}
                fullWidth
                multiline
              />
              {this.state.imageUrl !== "data:" && (
                <img
                  src={this.state.imageUrl}
                  alt="item"
                  height="40%"
                  width="40%"
                  className="item-image"
                />
              )}
              <div className="image-wrapper">
                <ImageUploader
                  withIcon={true}
                  buttonText="Upload Image"
                  onChange={this.handleImageChange.bind(this)}
                  imgExtension={[".jpg", ".gif", ".png", ".jpeg"]}
                  //maxFileSize={5242880}
                />
              </div>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.submitButton}
                disabled={loadingNewPost}
              >
                Submit
                {loadingNewPost && (
                  <CircularProgress
                    size={30}
                    className={classes.progressSpinner}
                  />
                )}
              </Button>
            </form>
          </DialogContent>
        </Dialog>
      </Fragment>
    ) : null;
  }
}

PostPost.propTypes = {
  user: PropTypes.object.isRequired,
  postPost: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  getProductFromUrl: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  UI: state.UI,
  user: state.user,
});

export default connect(mapStateToProps, {
  postPost,
  clearErrors,
  getProductFromUrl,
})(withStyles(styles)(PostPost));
